import React, { useState } from "react";

import { Navbar2, Footer, Impact, Gallery, Team } from "../components";
// import groupPic from "../assets/group-4.jpeg";
// import groupPic from '../assets/group-3.jpg'
import { AppButton } from "../utils";

function About(props) {
  const [visible, setVisible] = useState(false);

  const handleClick = () => {
    setVisible(!visible);
  };
  return (
    <div className="h-full ">
      <div
        // style={{ backgroundImage: `url(${groupPic}) ` }}
        className="bg-about bg-no-repeat bg-cover h-full "
      >
        <div className="max-w-7xl mx-auto">
          <Navbar2 />
        </div>
        <h1 className="text-9xl font-montserrat font-bold text-center text-black filter drop-shadow-2xl mt-36">
          About Us
        </h1>
        <h1
          className="text-9xl font-montserrat font-bold text-center text-white filter drop-shadow-2xl ml-4"
          style={{ marginTop: "-120px" }}
        >
          About Us
        </h1>
      </div>
      <section className="mt-40 max-w-7xl mx-auto font-montserrat">
        <h1 className="text-center font-semibold text-4xl md:text-5xl lg:text-7xl text-mix-400 font-josefin">
          Our Belief
        </h1>
        <p className="text-center font-normal text-md md:text-lg lg:text-xl mt-16">
          Drishti believes in the greater good. Service to all those in the
          community, no strings attached. We do not want to be credited for our
          work for any other reason than to increase our reach so that we help
          more and more people.
        </p>
        {visible && (
          <div className="mt-8">
            <h3 className="text-center font-semibold text-2xl">
              Sounds too good to be true?
            </h3>
            <p className="text-center font-normal text-md md:text-lg lg:text-xl mt-8">
              We are all under the same sky , some can afford a shade from the
              extremities of nature , some cannot. Helping people is not a task
              , it's the inherent reaction to someone in need. Here , we serve
              both financially and with efforts , and we value no other
              appreciation more than the smiles of those whom we serve. It
              brings a certain kind of peace to feed someone or educate them or
              to plant trees for a greener Earth. It's not easy , but it's not
              hard either. It's all about intent. And we are proud to say that
              each and everyone of our member has the intent.
            </p>
          </div>
        )}
        <div className="justify-center flex mt-10">
          <AppButton
            text={visible ? `Read Less` : `Read More`}
            onClick={handleClick}
          />
        </div>
      </section>
      {/* <section className="mt-40 max-w-7xl mx-auto">
        <h1 className="text-center font-semibold text-7xl text-mix-400 font-josefin">
          How it all started!
        </h1>
      </section> */}

      <Impact />

      <Gallery />
      <Team />
      <Footer support />
    </div>
  );
}

export default About;
